module.exports = __webpack_public_path__ + "img/icon-foreman-flow.14640b0a.png";